import axios, { HttpStatusCode } from "axios";
import { logoutAsync } from "../authentication/authenticationSlice";
import { API_BASE_URL } from "../../config";

let storeInstance: any = null;

export const injectStore = (_store: any) => {
  storeInstance = _store;
};

const axiosInstance = axios.create({
  baseURL: API_BASE_URL + "/api",
  withCredentials: true,
});

axiosInstance.interceptors.request.use(
  (requestConfig) => {
    const token =
      storeInstance?.getState().authentication.userAuth?.access_token;
    if (token) {
      requestConfig.headers["Authorization"] = `Bearer ${token}`;
    }
    return requestConfig;
  },
  async (error) => {
    const { response } = error;
    if (response.status === HttpStatusCode.Unauthorized) {
      storeInstance?.dispatch(logoutAsync());
    }
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { response } = error;
    if (response.status === HttpStatusCode.Unauthorized) {
      storeInstance?.dispatch(logoutAsync());
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
